import { render } from "./NewPasswordRequiredAlert.vue?vue&type=template&id=ac8b7908"
import script from "./NewPasswordRequiredAlert.vue?vue&type=script&lang=js"
export * from "./NewPasswordRequiredAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__